import { camelCase, upperFirst } from "lodash";

// eslint-disable-next-line
export default function stringToComponentName(string) {
  return upperFirst(camelCase(string));
}
